/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Paragon
 */
export class Paragon {
    /**
     *
     * @type {string}
     * @memberof Paragon
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Paragon
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Paragon
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof Paragon
     */
    merchantControl: string;
    /**
     *
     * @type {string}
     * @memberof Paragon
     */
    endpoint: string;
    /**
     *
     * @type {boolean}
     * @memberof Paragon
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Paragon
     */
    autoApprove: boolean;
}
